module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.selectedGroup && _vm.selectedGroup.subgroups && _vm.selectedGroup.subgroups.length === 0) ? _c('span', [_vm._l((this.selectedGroup.subgroupExercises), function(currentExercise) {
    return (_vm.selectedGroup.subgroupExercises && _vm.selectedGroup.subgroupExercises.length > 0) ? _c('div', {
      key: currentExercise.id
    }, [_c('exercises', {
      attrs: {
        "subgroupExercise": currentExercise
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "btn btn-primary pull-right margin",
      attrs: {
        "type": "submit"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.back()
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('pages.exercise.back')))])], 1) : _vm._e()
  }), _vm._v(" "), (_vm.selectedGroup.subgroupExercises && _vm.selectedGroup.subgroupExercises.length === 0) ? _c('div', [_vm._v("\n   " + _vm._s(_vm.$t('pages.subgroups.emptySubgroup')) + "\n ")]) : _vm._e()], 2) : (_vm.examExercises && _vm.examExercises.length > 0) ? _c('span', _vm._l((_vm.examExercises), function(currentExercise, i) {
    return _c('div', {
      key: currentExercise.id
    }, [(_vm.examResults) ? _c('exercises', {
      attrs: {
        "index": i,
        "examExercise": currentExercise.data
      }
    }) : _c('div', [(_vm.exercisesNumber) ? _c('exercises', {
      attrs: {
        "index": i + _vm.indexOffset,
        "examExercise": currentExercise,
        "exercisesNumber": _vm.exercisesNumber
      }
    }) : _c('exercises', {
      attrs: {
        "index": i,
        "examExercise": currentExercise
      }
    })], 1)], 1)
  }), 0) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0388b9fd", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0388b9fd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/exercises/ExercisesList.vue
// module id = 1406
// module chunks = 1